export default "__VITE_ASSET__49521a19__"